import * as ImageZoom from './components/ImageZoom.css';
export default {
    ImageZoom
};
